// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"31e4f641","529":"31e4f641","820":"0bbf9374"}[chunkId] + ".chunk.css";
};